<template>
    <section class="dispatchOrder-table">
        <div class="dispatch-table-header">
            <el-button
                type="text"
                class="dispatch-refresh"
                icon="el-icon-refresh"
                @click="refresh"
                >刷新</el-button
            >
        </div>
        <table-box
            ref="tablePage"
            :columns="config.table.columns"
            :height="config.table.height"
            :selection="config.selection"
            :loading="loading"
            :rows="tableData"
            :actions="config.table.action"
            @action-click="actionClick"
        >
        </table-box>
        <m-page
            :current-page="currentPage"
            :pageData="config.page"
            :total="pageTotal"
            @on-page-change="pageChange"
            @on-size-change="sizeChange"
            class="page-container"
        ></m-page>
        <!-- 查看影像 -->
        <performance-previewFile
            ref="performancePreviewFile"
            :attachmentList="previewList"
        ></performance-previewFile>
        <!-- 查看影像 -->
    </section>
</template>
<script>
import tableBox from '@/components/lots/tableBox/Index.vue';
import mPage from '@/components/otpPanel/mPage';
import PerformancePreviewFile from '@/modules/transport/otp/components/PerformancePreviewFile';
import {
    getAchmentPage, attachmentDelete
}
    from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
import config from './config.js';
import { downloadFile } from './util.js';
// import { formatSearchData, validateSearchData } from './util';

export default {
    name: 'dispatchArrivalCheckInTable',
    components: { tableBox, mPage, PerformancePreviewFile },
    props: {
        infoId: {
            type: Number,
            default () {
                return '';
            }
        },
        status: {
            type: String,
            default () {
                return '';
            }
        },
        dictData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            config: config,
            loading: false,
            selected: [], // 选中数据
            tableData: [], // 列表数据
            page: {
                pageSize: 10,
                pageNo: 1
            },
            pageTotal: 0,
            currentPage: 1,
            fileUrl: '',
            previewList: []
        };
    },
    methods: {
        /**
         * @description 操作列事件处理
         * @event {事件类型} viewImg 查看影像
         * @row   {Object} 行数据
        */
        actionClick (event, row, rIndex) {
            /* eslint-disable indent */
            switch (event) {
                case 'viewImg':
                    this.previewList = [row];
                    this.$nextTick(() => {
                        this.$refs.performancePreviewFile.show();
                    });
                    break;
                case 'delete':
                    this.attachmentDelete(row.id);
                    break;
                case 'dowload':
                    downloadFile(row.name, row.path);
                    break;
                default:
                    break;
            }
        },

        // 页数改变
        sizeChange (data) {
            this.page.pageSize = data;
            this.getList();
        },
        // 切分页
        pageChange (data) {
            this.page.pageNo = data;
            this.getList();
        },
        /**
         * @getList 获取列表接口
         * @param {Object} searchParams 查询条件
         */
        async getList () {
            const param = {
                ...this.page,
                param: {
                    objType: 'ARRIVAL_REGISTER',
                    objId: this.infoId
                }
            };
            getAchmentPage(param).then(res => {
                if (res && +res.code === 0) {
                    res.data.list.forEach(e => {
                        e.registrationStatus = this.status;
                        e.objTypeName = e.objType ? this.dictData.OTP_ATTACHMENT_TYPE[e.objType] : '';
                    });
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.totalCount || 0;
                }
            });
        },
        /**
         * @description 文件删除
         * @param {String} id  文件id
         */
        attachmentDelete (id) {
            attachmentDelete(id).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('删除成功');
                    this.getList();
                }
            });
        },
        /**
         * @description 文件下载
         * @param {String} id  文件id
         */
        attachmentDownLoad (id) {
            attachmentDelete(id).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('删除成功');
                    this.getList();
                }
            });
        },
        // 刷新
        refresh () {
            this.getList();
        }
    },
    watch: {
        infoId: {
            handler (val) {
                this.getList();
            },
            immediate: true
        }
    }

};
</script>

<style  lang="less" scoped>
.dispatchOrder-table {
    .mPane3-back-up .el-table {
        min-height: inherit;
    }
}
.dispatchOrder-table .model-table-search {
    display: none;
}
</style>
